// extracted by mini-css-extract-plugin
export default {"Radish":"#C20026","error":"G4ee071 G5cce1c","icon":"G6f740b G5e65f6","errorIcon":"Ge4c470 G6f740b G5e65f6 G4dd1d8"};